//action
import {
    SEND_OTP_FOR_FORGOT_PASSWORD,
    SEND_OTP_FOR_FORGOT_PASSWORD_FAIL,
    SEND_OTP_FOR_FORGOT_PASSWORD_SUCCESS,
    SEND_OTP_FOR_FORGOT_PASSWORD_RESET
} from "../action/sendOtpForForgotPasswordAction"
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {

        case SEND_OTP_FOR_FORGOT_PASSWORD:
            return {
                ...state,
                apiState: "loading"
            }
        case SEND_OTP_FOR_FORGOT_PASSWORD_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SEND_OTP_FOR_FORGOT_PASSWORD_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response,
                message: action.response && action.response.data && action.response.data.message || api_err_msg
            }
        case SEND_OTP_FOR_FORGOT_PASSWORD_RESET:
            return initialState
        default:
            return state
    }
}